export default {"verifyEmail":"_-39tH","iconContainer":"oQVSz","icon":"hX145","title":"wPq-0","content":"_6cNDj","text":"MIGPu"};